import styled from 'styled-components';
import { Box } from '@rsos/components/capstone/base';
import InputText from '@rsos/components/capstone/base/form/inputs/InputText';

export const IconWrapper = styled(Box).attrs(({ isInputFocused, theme }) => ({
  justify: 'center',
  height: '100%',
  align: 'center',
  px: '10px',
  color: `secondaryText`,
  borderRight: `1px solid ${
    isInputFocused ? theme.colors.primaryBase : theme.colors.heavyLineOutline
  }`,
}))``;

export const StyledInputText = styled(InputText)`
  text-indent: 10px;
`;
